module.exports = __webpack_public_path__ + "static/media/key.ef54c9db.png";